import { onGameEvent, EVENTS } from './game-events.js'
import {
    getLetterTiles,
    getValidWordRows,
    focusGuessInput,
    revealTiles,
    shakeTiles,
} from './dom.js'
import { showMessage } from './messages.js'

const shakeLetterTiles = () => shakeTiles(getLetterTiles(), 'border-red-400!')

/**
 * Fired after every guess submission (see itword/views.py).
 * event.detail.value is the guess's validity.
 */
onGameEvent(EVENTS.GUESS_SUBMITTED, (event) => {
    const guessWasValid = event.detail.value

    if (guessWasValid) {
        const rows = getValidWordRows()
        const row = rows[rows.length - 1]
        revealTiles(row, row.querySelectorAll('.valid-word-letter'))
    } else {
        // Recorded guesses are only invalid for not being in the Word table.
        showMessage('Not in word list')
        shakeLetterTiles()
    }

    // htmx settles the new row before this event fires. The guess input
    // itself is never swapped out, so on iOS it keeps focus and the
    // keyboard; this brings the new row into view.
    focusGuessInput()
})

/**
 * Fired with GUESS_SUBMITTED when the player uses their reveal, which
 * answers the round for no points.
 */
onGameEvent(EVENTS.GUESS_REVEALED, () => {
    showMessage('Answer revealed, no points this round')
})

/**
 * Fired when the round has no word to reveal. Nothing is swapped, and the
 * reveal isn't used up.
 */
onGameEvent(EVENTS.REVEAL_UNAVAILABLE, () => {
    showMessage('No answer to reveal this round')
})

/**
 * Fired when a guess is the wrong length for the round, i.e. submitted
 * before every tile was filled. Nothing is swapped, so the row is still as
 * the player left it.
 */
onGameEvent(EVENTS.GUESS_REJECTED, () => {
    showMessage('Fill in every letter')
    shakeLetterTiles()
    focusGuessInput()
})

/**
 * Fired when a guess no longer fits the round, e.g. a guess from another tab
 * moved the game on since this page was rendered.
 */
onGameEvent(EVENTS.GUESS_OUT_OF_SYNC, () => {
    showMessage('Game updated elsewhere, refresh to continue')
    shakeLetterTiles()
})
